/* eslint-disable indent */

import styled from 'styled-components';

export const TableWrapper1 = styled.div`
  ${'' /* padding: 1rem; */}
  padding-top:1rem;
  ${
    '' /* These styles are suggested for the table fill all available space in its containing element */
  }
  display: block;
  ${
    '' /* These styles are required for a horizontaly scrollable table overflow */
  }
  ${'' /* overflow: auto; */}
  .table * {
    box-sizing: border-box;
  }
  .table {
    .tr {
      ${'' /* margin-bottom: 5px; */}
    }

    .th,
    .td {
      ${'' /* background-color: #fff; */}
      margin: 0px;
      border-right: 0px solid black;
      ${'' /* margin-bottom: 5px; */}
      -webkit-box-flex: 1;
      -ms-flex: 1 0 0px;
      flex: 1 0 0;
      padding: 0.4em 0.6em;
      -webkit-transition: 0.3s ease;
      transition: 0.3s ease;
      -webkit-transition-property: width, min-width, padding, opacity;
      transition-property: width, min-width, padding, opacity;
      align-self: center;
      text-align: left;
      ${
        '' /* In this example we use an absolutely position resizer,
       so this is required. */
      }
      position: relative;

      :last-child {
        border-right: 0;
      }

      .resizer {
        right: 0;
        background: transparent;
        width: 3px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 1;
        ${'' /* prevents from scrolling while dragging on touch devices */}
        touch-action :none;

        &.isResizing {
          background: #479541;
        }
      }
    }
    .content-overflow {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .grey-column {
      color: #919194 !important;
    }
  }

  .transparent-btn,
  .transparent-btn:not(:disabled):not(.disabled):hover,
  .transparent-btn:not(:disabled):not(.disabled):active {
    color: #333 !important;
    background-color: transparent !important;
    border-color: transparent !important;
  }
  .transparent-btn.dropdown-toggle::after {
    display: none;
  }
  .sort-directions-icon {
    font-size: 16px;
    padding: 3px;
  }

  .filter-btn-selected {
    color: green !important;
  }
  .filter-btn-normal {
    color: #333 !important;
    opacity: 0.7;
  }
  .filter-btn-normal:not(:disabled):not(.disabled):hover,
  .filter-btn-normal:not(:disabled):not(.disabled):active {
    opacity: 1;
  }
`;

export const GridHeader = styled.div`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;
  color: #000000;
  .cell-content {
    opacity: 0.5;
    :hover {
      opacity: 1;
    }
  }
  :hover {
    color: #000000;
  }
`;

export const SortOrderIcon = styled.div`
  display: inline;
  color: #469542;
`;

export const GridRow = styled.div`
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(38, 38, 65, 0.1);
  border-radius: 5px;
`;

export const GridColText = styled.div`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: #000000;
`;
